import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSelectChange } from '@angular/material/select';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

import { IActionDef, IColumnDef } from '@shared/interfaces';

@Component({
  selector: 'el-base-neo-data-table-list',
  templateUrl: './data-table-list.component.html',
  styleUrls: ['./data-table-list.component.scss'],
})
export class DataTableListComponent implements OnInit, OnChanges {
  @Input() columns: IColumnDef[] = [];
  @Input() actions: IActionDef[] = [];
  @Input() actionColName?: string; //optional
  @Input() data: unknown[];
  @Input() pageSizeOptions: number[] = [5, 10, 25, 100];
  @Input() showFirstLastButtons = true;

  @Output() rowClick = new EventEmitter<any>();
  @Output() columnClick = new EventEmitter<{ column: string; row: any }>();
  @Output() pageChange = new EventEmitter<number>();
  @Output() sortChange = new EventEmitter<any>();

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  dataSource!: MatTableDataSource<any>;
  displayedColumns: string[] = [];
  pageSize = 10;

  ngOnInit() {
    this.initializeTable();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.data && !changes.data.firstChange) {
      this.initializeTable();
    }
  }

  private initializeTable() {
    this.dataSource = new MatTableDataSource(this.data);
    this.displayedColumns = this.columns.map((col) => col.key);

    if (this.actions && this.actions.length > 0) {
      // this use to, keep a table specific column without showing the name
      // if you wanna add an action column name please use the about @Input decorator to add that
      this.displayedColumns.push('actions');
    }

    if (this.paginator) {
      this.dataSource.paginator = this.paginator;
    }
    if (this.sort) {
      this.dataSource.sort = this.sort;
    }
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  onRowClick(row: any) {
    this.rowClick.emit(row);
  }

  onColumnClick(column: IColumnDef, row: any, event: Event) {
    if (column.clickable) {
      event.stopPropagation();
      this.columnClick.emit({ column: column.key, row });
    }
  }

  onActionClick(event: Event, action: IActionDef, row: any) {
    event.stopPropagation();
    action.onClick(row);
  }

  hasColumnIcon(column: IColumnDef): boolean {
    // temporary block for the first column
    // if you need to add icons to specific columns please remove this condition if `indexOf(column) === 0`
    return this.columns.indexOf(column) === 0 && !!column.icon;
  }

  onChangePageSize(event: MatSelectChange) {
    this.pageSize = event.value;
  }

  onTriggerShowMore() {
    this.pageChange.emit(this.pageSize);
  }
}
